var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrarCruzGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.276,
    height: 18.276,
    viewBox: "0 0 18.276 18.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218",
    "data-name": "Trazado 218",
    d: "M896.609,62.694l-2.482-2.482-6.657,6.657-6.657-6.657-2.482,2.482,6.657,6.657-6.657,6.657,2.482,2.482,6.657-6.657,6.657,6.657,2.482-2.482-6.657-6.657Z",
    transform: "translate(-878.333 -60.212)",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarCruzGris);
export default __webpack_public_path__ + "static/media/cerrar-cruz-gris.326f2e87b8ab88f758a9b514d47a8261.svg";
export { ForwardRef as ReactComponent };